// Styles for HotNews (extracted from JSX in Phase 2)

export const s = {
    page: {
        maxWidth: '95%',
        margin: '0 auto 50px',
        paddingTop: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    photo: {
        display: 'block',
        width: '100%',
        borderRadius: '12px',
        boxShadow: '0 6px 20px rgba(92, 61, 46, 0.15)',
    },
}
